const deepCopyObject = (obj) => {
  if (obj === null || typeof obj !== 'object') return obj;
  if (obj instanceof Date) return new Date(obj.getTime());
  if (Array.isArray(obj)) return obj.map(deepCopyObject);
  return Object.keys(obj).reduce((acc, prop) => ({ ...acc, [prop]: deepCopyObject(obj[prop]) }), {});
};

export default deepCopyObject;
